import { Link } from "react-router-dom";

// Reusable privacy acknowledgement label for all forms.
// Acknowledgement only — it does NOT present acceptance of the Privacy Notice
// as consent to necessary processing.
export default function PrivacyLabel() {
  return (
    <>
      I have read and understood the{" "}
      <Link
        to="/privacy"
        target="_blank"
        className="font-medium text-brand-green underline underline-offset-2 hover:text-brand-greenDeep"
      >
        Privacy Notice
      </Link>
      .
    </>
  );
}
